import * as React from 'react';

export interface IDialogContext {
  onCancel: () => void;
  onCloseDialog: () => void;
  onSave: () => void;
}

export const defaultContext: IDialogContext = Object.freeze({
  onCancel: () => null,
  onCloseDialog: () => null,
  onSave: () => null
});

export const defaultValue = Object.freeze({
  onCancel: () => {
    console.warn('DialogContext: onCancel has not been provided');
  },
  onCloseDialog: () => {
    console.warn('DialogContext: onCloseDialog has not been provided');
  },
  onSave: () => {
    console.warn('DialogContext: onSave has not been provided');
  }
});

const DialogContext = React.createContext<Partial<IDialogContext>>(defaultValue);

DialogContext.displayName = 'BzCoreControls-DialogContext';

export default DialogContext;
